import { Form, FormGroup, Label } from '@wyz/ui';
import * as React from 'react';
type AlphabeticalListSearchInputProps = {
  value: string;
  label: React.ReactNode;
  placeholder: string;
  onChange: (value: string) => void;
};

const AlphabeticalListSearchInput = ({
  onChange,
  label,
  placeholder,
  value,
}: AlphabeticalListSearchInputProps) => {
  return (
    <FormGroup>
      <Label htmlFor='searchQuery'>{label}</Label>
      <Form.Control
        id={'searchQuery'}
        value={value}
        onChange={({ target }) => onChange(target.value)}
        type={'search'}
        placeholder={placeholder}
        data-cy={'searchQuery'}
      />
    </FormGroup>
  );
};

export default AlphabeticalListSearchInput;
